module.exports = __webpack_public_path__ + "img/cut_xianlai3.1dd5e682.png";